import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { IFrameContainer } from './IFrameContainer';
const win = typeof window !== 'undefined' ? window : undefined;
const apiPromise = new Promise(resolve => {
  if (win && !win.FB) {
    const script = document.createElement('script');
    script.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2';
    document.body.appendChild(script);
    const originalFbAsyncInit = win.fbAsyncInit;
    win.fbAsyncInit = () => {
      if (originalFbAsyncInit) {
        originalFbAsyncInit();
      }
      resolve();
    };
  }
});
const PlayerAPI = props => {
  const {
    player,
    playing,
    muted
  } = props;
  useLayoutEffect(() => {
    muted ? player.mute() : player.unmute();
  }, [player, muted]);
  useLayoutEffect(() => {
    playing ? player.play() : player.pause();
  }, [player, playing]);
  return null;
};
const Player = props => {
  const {
    size,
    src,
    onEnd,
    onPlay,
    onPause,
    onPlayerReady
  } = props;
  const [player, setPlayer] = useState();
  const ref = useRef(null);
  const handleReady = useCallback(message => {
    if (message.type === 'video' && message.id === src) {
      const instance = message.instance;
      setPlayer(instance);
      onPlayerReady && onPlayerReady(instance);
      onPlay && instance.subscribe('startedPlaying', onPlay);
      onPause && instance.subscribe('paused', onPause);
      onEnd && instance.subscribe('finishedPlaying', onEnd);
    }
  }, [src, onPlay, onPause, onEnd]);
  const setAllowAttribute = useCallback(() => {
    var _ref$current;
    const iframe = (_ref$current = ref.current) == null ? void 0 : _ref$current.querySelector('iframe');
    if (!iframe) {
      return;
    }
    const allows = iframe.allow.split(' ').map(i => i.trim());
    if (!allows.includes('autoplay')) {
      allows.push('autoplay');
      iframe.setAttribute('allow', allows.join(';'));
      iframe.setAttribute('src', iframe.src);
    }
  }, []);
  useEffect(() => {
    win.FB.init({
      xfbml: true,
      version: 'v3.2'
    });
  }, []);
  useEffect(() => {
    win.FB.Event.subscribe('xfbml.ready', handleReady);
    win.FB.Event.subscribe('iframeplugin:create', setAllowAttribute);
    return () => {
      win.FB.Event.unsubscribe('xfbml.ready', handleReady);
      win.FB.Event.unsubscribe('iframeplugin:create', setAllowAttribute);
    };
  }, [handleReady, setAllowAttribute]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "fb-video",
    id: src,
    ref: ref,
    "data-href": src,
    "data-height": size.height,
    "data-width": size.width,
    "data-show-text": "false",
    "data-allowfullscreen": "true"
  }), player ? /*#__PURE__*/React.createElement(PlayerAPI, _extends({}, props, {
    player: player
  })) : null);
};
export const Facebook = props => {
  const [apiLoaded, setApiLoaded] = useState(false);
  useEffect(() => {
    apiPromise.then(() => setApiLoaded(true));
  }, []);
  return /*#__PURE__*/React.createElement(IFrameContainer, {
    poster: props.poster
  }, size => {
    if (!apiLoaded) {
      return null;
    }
    return /*#__PURE__*/React.createElement(Player, _extends({}, props, {
      size: size,
      key: props.src
    }));
  });
};
//# sourceMappingURL=Facebook.js.map